import React from "react";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { focusSelector, focusSelectorQuery } from "../../../lib/focusSelector";

const SkipLinks = function () {
  const { t } = useTranslation();

  function handleOnClick() {
    let focusable = focusSelector(document.getElementById("main"));
    // In case we're using the widget KHeaderWidget, skip the first one we encounter
    if (document.getElementsByClassName("KHeaderWidget").length !== 0) {
      const focusables: Element[] = [];
      document
        .getElementById("main")
        ?.querySelectorAll(focusSelectorQuery)
        .forEach((node: Element) => {
          if (
            !document.getElementsByClassName("KHeaderWidget")[0].contains(node) &&
            node.id !== "SkipLinks"
          ) {
            focusables.push(node);
          }
        });
      focusable = focusables[0] as HTMLElement;
    }

    focusable?.focus();
  }

  return (
    <Button
      onClick={handleOnClick}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
        position: "absolute",
        top: "-10rem",
        left: "1rem",
        "&:focus": {
          top: "1rem",
        },
      }}
      id="SkipLinks"
      variant="contained"
    >
      {t("skipLinks.title")}
    </Button>
  );
};

export default SkipLinks;
